import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function chartKpiSubValue(theme: Theme): ComponentStyle {
  return {
    componentName: 'chartKpiSubValue',
    baseStyle: {
      color: theme.colors.muted,
      fontSize: theme.sizes['-1']
    }
  };
}
